/**
 * The nearest ancestor that actually scrolls. Resolved from an element rather
 * than from a React ref: the lobby renders more than one `.scroll` (one per
 * format panel), and a ref can still be null when a child's callback ref
 * fires, so publishing measured vars against a ref silently wrote nothing and
 * left the pin chain on its 0px fallbacks. Walking up from the element cannot
 * pick the wrong panel or run too early.
 */
export const scrollRootOf = (el: HTMLElement | null): HTMLElement | null => {
  let n: HTMLElement | null = el?.parentElement ?? null;
  while (n) {
    const oy = getComputedStyle(n).overflowY;
    if (oy === 'auto' || oy === 'scroll') return n;
    n = n.parentElement;
  }
  return null;
};
